import React from "react"

//Components
import Home from './screens/home'

function App() {
  return (
    <Home />
  )
}

export default App
